import { DataList } from "../types"

export const calculateSummary = (data: DataList[]) => {

  return data.reduce((acc, val) => {
    // Vars
    const payable_age = val.payable_age

    if (payable_age <= 7) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "7_day": acc["7_day"] + val?.balance
      }
    } else if (payable_age >= 8 && payable_age <= 15) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "15_day": acc["15_day"] + val?.balance
      }
    } else if (payable_age >= 16 && payable_age <= 21) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "21_day": acc["21_day"] + val?.balance
      }
    } else if (payable_age >= 22 && payable_age <= 30) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "30_day": acc["30_day"] + val?.balance
      }
    } else if (payable_age >= 31) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "60_day": acc["60_day"] + val?.balance
      }
    }

    return acc
  }, {
    balance: 0,
    "7_day": 0,
    "15_day": 0,
    "21_day": 0,
    "30_day": 0,
    "60_day": 0
  })
}